import { blue } from 'bold-ui/lib/styles/colors'
import React from 'react'

import { SoapSection } from '../SoapSection'
import { ObjetivoFormProps } from '.'
import ObjetivoForm from './ObjetivoForm'

export function ObjetivoSection(props: Readonly<ObjetivoFormProps>) {
  return (
    <SoapSection initial='O' title='Objetivo' color={blue}>
      <ObjetivoForm {...props} />
    </SoapSection>
  )
}
